/*
 * strova pdpx
 * Autoplay fuer UGC-Videos in den neuen PDP-Sektionen.
 *
 * Ein Video startet erst, wenn es sichtbar wird, laeuft stumm und in Schleife und haelt an,
 * sobald es den Bildschirm verlaesst. Vor dem ersten Sichtkontakt liegt nur das Posterbild
 * im DOM — das Video wird erst dann eingehaengt. Dadurch kostet die Sektion beim
 * Seitenaufruf nichts.
 *
 * Ohne IntersectionObserver (sehr alte Browser) bleibt das Posterbild stehen und der
 * Nutzer startet per Klick — die bestehende strova-video.js uebernimmt das.
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  function mount(slot) {
    var existing = slot.querySelector('video');
    if (existing) return existing;

    var template = slot.querySelector('[data-st-video-source]');
    if (!template) return null;

    slot.appendChild(template.content.cloneNode(true));
    var video = slot.querySelector('video');
    if (!video) return null;

    video.muted = true;
    video.loop = true;
    video.controls = false;
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');

    var poster = slot.querySelector('.st-video__poster');
    if (poster) poster.style.display = 'none';
    slot.classList.add('is-playing');

    return video;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var slot = entry.target;
      if (entry.isIntersecting) {
        var video = mount(slot);
        if (!video) return;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      } else {
        var playing = slot.querySelector('video');
        if (playing && !playing.paused) playing.pause();
      }
    });
  }, { threshold: 0.4 });

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-st-autoplay] [data-st-video]').forEach(function (slot) {
      if (slot.dataset.stAutoReady) return;
      slot.dataset.stAutoReady = '1';
      slot.dataset.stReady = '1';
      var button = slot.querySelector('[data-st-video-play]');
      if (button) button.remove();
      observer.observe(slot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
